import React from 'react'

export default function ResinousCoverageDetailsModals(props) {
   const {
      availableColors,
       availableChipColors,
       availableQuartzColors,
      setChipValue,
       setColorValue,
       setColorSku,
       setColorChipSku,
      setStateChipValue,
      setStateColorValue,
      setColorImage,
       setChipImage,
       setColorCoverage,
       setColorChipCoverage,
      systemTypeName
   } = props

    let chipOrQuartzColors
    let isQuartz

    if (availableQuartzColors.length > 0) {
        chipOrQuartzColors = availableQuartzColors;
        isQuartz = true
    } else {
        chipOrQuartzColors = availableChipColors;
        isQuartz = false
    }

   function handleColorSelect(colorName, colorImage, colorSku, colorCoverage) {
       setColorValue(colorName)
      setStateColorValue(colorName)
       setColorImage(colorImage)
       setColorSku(colorSku)
       setColorCoverage(colorCoverage)
   }
    function handleChipSelect(chipName, chipImage, colorChipSku, colorChipCoverage) {
      setChipValue(chipName)
      setStateChipValue(chipName)
       setChipImage(chipImage)
       setColorChipSku(colorChipSku)
        setColorChipCoverage(colorChipCoverage)

        

        // Get the recommended chip in preparation for setting it in the UI.
        if (availableQuartzColors.length > 0) {
            chipOrQuartzColors = availableQuartzColors;
            isQuartz = true
        } else {
            chipOrQuartzColors = availableChipColors;
            isQuartz = true
        }

        let recommendedColor = chipOrQuartzColors.map(cc => {
         return availableColors.map(c => {
             return chipName === cc.Name && cc.DefaultNonChipColor === c.Name && c.Name
         }).filter(Boolean).toString()
        })

        // Filter out all falsies, convert array to string, remove any string text that includes parentheses: ex: "(1 Quart)""
        recommendedColor = recommendedColor.filter(el => {
            return el !== null && el !== '';
        }).toString().replace(/ *\([^)]*\) */g, "")
        
        let recommendedSkuColor = chipOrQuartzColors.map(cc => {
           return chipName === cc.Name && cc.DefaultNonChipColor
       }).filter(Boolean).toString()

        let defaultColorSku = availableColors.map(c => {
            return (c.Name.indexOf(recommendedColor) > -1) && c.Sku
        }).filter(Boolean)

      // Set the color value of the recommended color if it exists
      recommendedColor && setColorValue(recommendedColor)
      // If recommendedColor exists, set in state
       recommendedColor && setStateColorValue(recommendedColor)
        recommendedColor && setColorSku(defaultColorSku)
   }

   return (
      <React.Fragment>
         <div className="modal fade" id="availableResinousChips" tabIndex="-1" role="dialog" aria-labelledby="availableResinousChipsLabel" aria-hidden="true">
            <div className="modal-dialog modal-chip-and-color" role="document">
               <div className="modal-content">
                  <div className="modal-header">
                           <h3 className="modal-title" id="availableResinousChips">Select {isQuartz ? "Quartz" : "Chip" }</h3>
                     <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                     </button>
                  </div>
                  <div className="modal-body">
                     <div className="row p-1">
                     {
                        // Create an option for each available chip color.
                                   chipOrQuartzColors.map((chip, index) => {
                           const chipName = chip.Name.replace(/ *\([^)]*\) */g, "")
                           const chipNameDetail = chip.Name.replace(/^.*\(|\)/g, '')
                           return (
                              <div className="col-xs-6 col-sm-3 swatch" key={ chip.Sku+"_"+index }>
                                 <img
                                    alt={ chip.Name }
                                    src={ chip.ColorOrChipImage ? "https://cdn.laticrete.com/" + chip.ColorOrChipImage : "http://via.placeholder.com/737x737" }
                                    className="img-responsive"
                                    data-bs-dismiss="modal"
                                       onClick={() => handleChipSelect(chip.Name, chip.ColorOrChipImage, chip.Sku, chip.Coverage) }
                                 />
                                 { isQuartz ? <h4>{ chipName }</h4> : <h4>{ chipName }<small>{ chipNameDetail }</small></h4> }
                              </div>
                           )
                        })
                     }
                     </div>
                  </div>
                  <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                  </div>
               </div>
            </div>
         </div>
         <div className="modal fade" id="availableResinousColors" tabIndex="-1" role="dialog" aria-labelledby="availableResinousColorsLabel" aria-hidden="true">
            <div className="modal-dialog modal-chip-and-color" role="document">
               <div className="modal-content">
                  <div className="modal-header">
                     <h3 className="modal-title" id="availableResinousColors">Select Color</h3>
                     <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                     </button>
                  </div>
                  <div className="modal-body">
                           <div className="row p-1">
                     {
                        // Create an option for each available color.
                        availableColors.map(color => {
                            const colorName = color.Name.replace(/ *\([^)]*\) */g, "")
                           return (
                              <div className="col-xs-6 col-sm-3 swatch" key={ color.Sku }>
                                 <img
                                       alt={ color.Name }
                                       src={ color.ColorOrChipImage ? "https://cdn.laticrete.com/" + color.ColorOrChipImage : "http://via.placeholder.com/737x737" }
                                       className="img-responsive"
                                       data-bs-dismiss="modal"
                                       onClick={ () => handleColorSelect(colorName, color.ColorOrChipImage, color.Sku, color.Coverage) }
                                 />
                                 <h4>{ colorName }</h4>
                              </div>
                           )
                        })
                     }
                     </div>
                  </div>
                  <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                  </div>
               </div>
            </div>
           </div>
           

         <div className="modal fade" id="modal-vaporBarrier" tabIndex="-1" role="dialog" aria-labelledby="modal-vaporBarrier" aria-hidden="true">
            <div className="modal-dialog" role="document">
               <div className="modal-content">
                  <div className="modal-header">
                     <h3 className="modal-title">Vapor Barrier</h3>
                  </div>
                  <div className="modal-body">
                     <div className="row p-1">
                        <div className="col-xs-12">
                           <p>Vapor Barriers protect the system from moisture vapor transmission through the slab. Use anytime the moisture in the concrete measures &gt;75% RH per ASTM F2170 or &gt;3 lbs per 1000 ft<sup>2</sup> per ASTM F1869.</p>
                           <a href="# " className="btn btn-primary" data-bs-dismiss="modal">CLOSE</a>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div className="modal fade" id="modal-substratePreparation" tabIndex="-1" role="dialog" aria-labelledby="modal-substratePreparation" aria-hidden="true">
            <div className="modal-dialog" role="document">
               <div className="modal-content">
                  <div className="modal-header">
                        <h3 className="modal-title">Substrate Preparation</h3>
                  </div>
                  <div className="modal-body">
                        <div className="row p-1">
                           <div className="col-xs-12">
                              <p>Concrete Surface Profile (CSP) is a measure of the surface roughness achieved during substrate preparation ranging from 1 (smoothest) to 10 (roughest).  A rougher surface profile will require additional material.</p>
                              <a href="# " className="btn btn-primary" data-bs-dismiss="modal">CLOSE</a>
                           </div>
                        </div>
                  </div>
               </div>
            </div>
         </div>
         <div className="modal fade" id="modal-tractionAdditive" tabIndex="-1" role="dialog" aria-labelledby="modal-tractionAdditive" aria-hidden="true">
            <div className="modal-dialog" role="document">
               <div className="modal-content">
                  <div className="modal-header">
                     <h3 className="modal-title">Traction Additive</h3>
                  </div>
                  <div className="modal-body">
                     <div className="row p-1">
                        <div className="col-xs-12">
                           <p>Traction additives may be added to the topcoat to increase the texture and anti-skid properties of the final floor.</p>
                           <a href="# " className="btn btn-primary" data-bs-dismiss="modal">CLOSE</a>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div className="modal fade" id="modal-preferredPackagingSize" tabIndex="-1" role="dialog" aria-labelledby="modal-preferredPackagingSize" aria-hidden="true">
            <div className="modal-dialog" role="document">
               <div className="modal-content">
                  <div className="modal-header">
                     <h3 className="modal-title">Preferred Packaging Size</h3>
                  </div>
                  <div className="modal-body">
                     <div className="row p-1">
                        <div className="col-xs-12">
                           <p>Selecting Large units will change products to the largest available unit size.  For larger projects (greater than 10K ft<sup>2</sup>) this may be preferred.</p>                                    <a href="# " className="btn btn-primary" data-bs-dismiss="modal">CLOSE</a>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </React.Fragment>
   )
}



// WEBPACK FOOTER //
// ./src/components/productTypes/resinous/ResinousCoverageDetailsModals.js